import { Container } from "react-bootstrap";
import './FeedbackClients.css'
import RowOne from "./RowOne";
import RowTwo from "./RowTwo";






export default function FeedbackClients() {
  return (
    <section
      id="feedback-clients"
      className="feedback-clients"
    >
      <Container>
        <RowOne />
        <RowTwo />
      </Container>
    </section>
  );
}
